var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10888 15.4492L6.11054 18.9776C6.10999 19.2271 6.15876 19.4743 6.25403 19.705C6.34931 19.9356 6.48922 20.1452 6.66573 20.3216C7.02536 20.6812 7.50431 20.8785 8.01144 20.8785L11.8099 20.8785C12.0595 20.879 12.3067 20.8302 12.5373 20.735C12.768 20.6397 12.9776 20.4998 13.154 20.3233C13.5136 19.9636 13.7108 19.4847 13.7108 18.9776V16.2C14.7525 15.8085 15.8563 15.6086 16.969 15.61C18.0831 15.6072 19.1885 15.8054 20.2322 16.195L20.2322 18.9726C20.2317 19.2221 20.2805 19.4693 20.3757 19.7C20.471 19.9307 20.6109 20.1402 20.7874 20.3166C21.1471 20.6763 21.626 20.8735 22.1331 20.8735L25.9316 20.8768C26.1816 20.8773 26.4291 20.8283 26.6601 20.7327C26.891 20.6372 27.1008 20.4969 27.2773 20.32C27.637 19.9603 27.8342 19.4814 27.8342 18.9742L27.8342 15.4509C27.8358 14.6404 27.5077 13.8516 26.9343 13.2782C26.8133 13.1572 26.6873 13.0511 26.5531 12.9567C23.9512 11.0906 20.5471 10.063 16.9724 10.0614C13.4009 10.0597 10.0002 11.0872 7.38664 12.955C6.58949 13.5268 6.11219 14.4581 6.10888 15.4492Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.34d7c30452b818cc9d67fe2c549e5e83.svg";
export { ForwardRef as ReactComponent };